module.exports = __webpack_public_path__ + "static/img/刮板机辅助找直检测.c646d8f9.png";